(function () {
  // Only run on the booking page
 var isBookingPage = /\/pages\/book-installation\/?$/.test(window.location.pathname);
if (!isBookingPage) return;

// If arriving with email parameters, allow auto-add to run first
var params = new URLSearchParams(window.location.search);
if (params.get("main")) return;

  // If we already have a cart item, let them continue
  fetch("/cart.js", { credentials: "same-origin" })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var hasItems = cart && Array.isArray(cart.items) && cart.items.length > 0;
      if (!hasItems) {
        // No cart => they likely came directly. Send them to the start.
        window.location.replace("/pages/get-a-free-quote");
      }
    })

    .catch(function () {
      // If cart fetch fails, do nothing (don't block bookings).
    });
})();